import React, {useState} from 'react';

import {InlineBannerType} from 'ui-library/banners/InlineBanner';
import {ButtonStyle} from 'ui-library/buttons/Button';
import TextField from 'ui-library/inputs/TextField';
import Modal from 'ui-library/modals/Modal';

import {InstrumentGateway} from './InstrumentGatewayConstants';

function validate(name: string, existingGateways: Array<InstrumentGateway>): string | null {
  if (name === '') {
    return 'Name is required';
  }
  for (const gateway of existingGateways) {
    if (gateway.name === name) {
      return 'Name must not be the same as an existing gateway.';
    }
  }
  return null;
}

interface CreateInstrumentGatewayModalProps {
  existingGateways: Array<InstrumentGateway>;
  onRequestClose: () => void;
  onRequestSubmit: (name: string) => void;
}

function CreateInstrumentGatewayModal(props: CreateInstrumentGatewayModalProps): JSX.Element {
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  return (
    <Modal
      buttons={[
        {
          style: ButtonStyle.SECONDARY,
          submit: true,
          text: 'Submit',
        },
      ]}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        const newError = validate(name, props.existingGateways);
        if (newError == null) {
          props.onRequestSubmit(name);
        } else {
          setError(newError);
        }
      }}
      title="Create instrument gateway"
      bannerProps={error ? {bannerType: InlineBannerType.ERROR, text: error} : null}
    >
      <TextField
        label="Name"
        isRequired={true}
        value={name}
        onChange={(e) => {
          setName(e.target.value);
        }}
        hasError={error != null}
      />
    </Modal>
  );
}

export default CreateInstrumentGatewayModal;
